import { render, staticRenderFns } from "./CoursesTable.vue?vue&type=template&id=1c5da328"
import script from "./CoursesTable.vue?vue&type=script&lang=js"
export * from "./CoursesTable.vue?vue&type=script&lang=js"
import style0 from "./CoursesTable.vue?vue&type=style&index=0&id=1c5da328&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports